var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.82353V21.5882C1 23.2126 2.31681 24.5294 3.94118 24.5294H14.2353M1 9.82353V3.94118C1 2.31681 2.31681 1 3.94118 1H24.5294C26.1538 1 27.4706 2.31681 27.4706 3.94118V9.82353M1 9.82353H27.4706M27.4706 9.82353V14.2353",
    stroke: "#3A1B50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3249 26.0003V17.1768M22.3249 17.1768L26.0014 20.8532M22.3249 17.1768L18.6484 20.8532",
    stroke: "#3A1B50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1.5,
    fill: "#3A1B50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 5.5,
    r: 1.5,
    fill: "#3A1B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCalendar);
export default __webpack_public_path__ + "static/media/img_calendar.a7861c90db8d4d6a6162e4170fc41d5b.svg";
export { ForwardRef as ReactComponent };